export default __webpack_public_path__ + "static/media/login_image.9a7f6969.png";